<script setup>
import {computed} from "vue";
import {game} from "@/utils/config";

const type = computed(() => game.qxdj)
</script>

<template>
  <el-scrollbar class="page-pid" height="100vh">
    <el-image :src="type.store_images" alt="" style="width: 100%;"/>
  </el-scrollbar>
</template>

<style scoped lang="less">

</style>
